<template>
  <div class="u-reg-line-wap">
    <div class="cut-off"></div>
  </div>
</template>
<script>
export default {
  name: "sk-line-wap"
};
</script>
<style lang=""></style>
